import React, {useState} from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import {ToastContainer, toast} from "react-toastify";
import axios from '../utils/axios';
import {Row, Col} from "react-bootstrap";
import UsaStates from "../pages/usaStates";
import Categories from "../pages/categories";

function BusinessRegister() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let [phone, setPhone] = useState("");
    let [name, setName] = useState("");
    let [password, setPassword] = useState("");
    let [confirmPassword, setConfirmPassword] = useState("");
    let [email, setEmail] = useState("");
    let [website, setWebsite] = useState("");
    let [street, setStreet] = useState("");
    let [city, setCity] = useState("");
    let [state, setState] = useState("NA");
    let [zipcode, setZipcode] = useState("");
    let [country, setCountry] = useState("USA");
    let [file, setFile] = useState(null);
    let [categories, setCategories] = useState([]);

    const [addAd, setAddAd] = useState(false);
    const [adImage, setAdImage] = useState('');
    const [adImageFile, setAdImageFile] = useState(null);

    const onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            setFile(img);
        }
    };

    const onAdImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            let imageURL = URL.createObjectURL(img);
            setAdImage(imageURL);
            setAdImageFile(img);
        }
    };

    const checkEmptyString = (value) => {
        value = value.trim();
        if (value === "") {
            return "NA";
        }
        return value;
    };

    const handleBusinessSubmit = () => {
        if (name === '') {
            toast('Business Name required!')
            return;
        } else if (email === '') {
            toast('Email required!')
            return;
        } else if (!email.includes('@')) {
            toast('Please provide a valid email!')
            return;
        } else if (password === '') {
            toast('Password required!')
            return;
        } else if (confirmPassword === '') {
            toast('Confirm your Password!')
            return;
        } else if (password !== confirmPassword) {
            toast(`Passwords don't match!`)
            return;
        }

        const json = {
            businessName: name,
            businessEmail: email,
            businessPassword: password,
            businessWebsite: checkEmptyString(website),
            businessPhone: checkEmptyString(phone),
            businessStreet: checkEmptyString(street),
            businessCity: checkEmptyString(city),
            businessState: state,
            businessZipcode: checkEmptyString(zipcode),
            businessCategories: categories,
            businessCountry: 'USA',
        };
        const formData = new FormData();
        for (const [key, value] of Object.entries(json)) {
            formData.append(key, value);
        }
        if (file) {
            formData.append("file", file);
        }
        if (adImageFile) {
            formData.append("file", adImage);
        }
        axios.post(
            "business/registerBusiness",
            formData,
            {
                headers: {
                    // Multer only parses "multipart/form-data" requests
                    'Content-Type': 'multipart/form-data',
                }
            })
            .then((response) => {
                // console.log(response);
                if (response.data.Message === "Business Registered Successfully") {
                    toast("Business Registered Successfully");

                    if (adImageFile) {
                        const adFormData = new FormData();
                        adFormData.append('file', adImageFile);
                        adFormData.append('SponsorCode', response.data.Data.advertisementCode);
                        axios.post("ad/adregister", adFormData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                            .then((response) => {
                                toast("Ad Published successfully");
                            })
                            .catch((e) => {
                                toast("Ad Could not be published!");
                            });
                    }
                    setTimeout(() => {
                        handleClose();
                        Window.location.reload();
                    }, 1000);
                } else if (response.data.Message === "Business already Registered against this Name") {
                    toast("Business Already Registered against this Name!");
                } else {
                    console.log(response.data);
                    toast('Could not register the Business');
                }
            })
            .catch(() => {
                toast("Something went wrong!");
            });
    };

    const handleInput = (e) => {
        // this is where we'll call the phoneNumberFormatter function
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        // we'll set the input value using our setInputValue
        setPhone(formattedPhoneNumber);
    };

    function formatPhoneNumber(value) {
        // if input value is falsy e.g. if the user deletes the input, then just return
        if (!value) return value;
        // clean the input for any non-digit values.
        const phoneNumber = value.replace(/[^\d]/g, "");
        // phoneNumberLength is used to know when to apply our formatting for the phone number
        const phoneNumberLength = phoneNumber.length;
        // we need to return the value with no formatting if it's less than four digits
        // this is to avoid weird behavior that occurs if you  format the area code to early
        if (phoneNumberLength < 4) return phoneNumber;
        // if phoneNumberLength is greater than 4 and less the 7 we start to return
        // the formatted number
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        // finally, if the phoneNumberLength is greater than seven, we add the last
        // bit of formatting and return it.
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
            3,
            6
        )}-${phoneNumber.slice(6, 10)}`;
    }

    return (
        <>
            <ToastContainer/>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
            </div>
            <div className='text-center'>
                <p style={{color: 'black'}}>Don't have an Account? <b style={{color: 'blue', cursor: 'pointer'}}
                                                                      onClick={handleShow}><u>Sign Up</u></b></p>
            </div>
            <Modal show={show} size={'lg'} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Register your Business</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Row>
                                <Col>
                                    <Form.Label>Enter your Business Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Business Name"
                                        autoFocus
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>Business Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="example@gmail.com"
                                        autoFocus
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: '10px'}}>
                                <Col>
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="********"
                                        autoFocus
                                        maxLength='8'
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="********"
                                        autoFocus
                                        maxLength='8'
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: '10px'}}>
                                <Col>
                                    <Form.Label>Business Website</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="www.example.com"
                                        autoFocus
                                        onChange={(e) => setWebsite(e.target.value)}
                                        value={website}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>Business Phone</Form.Label>
                                    <Form.Control
                                        type="phone"
                                        placeholder="(123) 456-7890"
                                        autoFocus
                                        onChange={(e) => handleInput(e)}
                                        value={phone}
                                    />
                                </Col>
                            </Row>
                            <h4 className='mt-4'>Categories</h4>
                            <hr/>
                            <Form.Label>Choose Categories:</Form.Label>
                            <Categories handler={setCategories}/>
                            <h4 className='mt-4'>Business Address</h4>
                            <hr/>
                            <Row style={{marginTop: '10px'}}>
                                <Col>
                                    <Form.Label>Street:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Street"
                                        autoFocus
                                        onChange={(e) => setStreet(e.target.value)}
                                        value={street}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>City:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="City"
                                        autoFocus
                                        onChange={(e) => setCity(e.target.value)}
                                        value={city}
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: '10px'}}>
                                <Col>
                                    <Form.Label>State:</Form.Label>
                                    <UsaStates handler={setState}/>
                                </Col>
                                <Col>
                                    <Form.Label>ZIP CODE:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="ZIP CODE"
                                        autoFocus
                                        onChange={(e) => setZipcode(e.target.value)}
                                        value={zipcode}
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: '10px'}}>
                                <Col>
                                    <Form.Label>Country:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        disabled
                                        placeholder="USA"
                                        autoFocus
                                        onChange={(e) => setCountry(e.target.value)}
                                        value={country}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>Add Business Logo:</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept='image/png, image/jpeg'
                                        autoFocus
                                        onChange={onImageChange}
                                        name='image'
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                {
                                    addAd ?
                                        <div>
                                            <div className="col-md-12">
                                                <h5> Add Advertisement</h5>
                                                <hr/>
                                                <p style={{color: 'red'}}>*Image should be Landscape Size 120*300</p>
                                            </div>
                                            <div className='container'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <input type='file' className='form-control'
                                                               accept='image/png, image/jpeg'
                                                               onChange={onAdImageChange}/>
                                                    </div>
                                                    <div className='col-md-6' style={{textAlign: 'right'}}>
                                                        <img alt='' src={adImage} className='w-100'/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className='text-end'>
                                            <button className='btn btn-primary' onClick={() => setAddAd(!addAd)}>Add
                                                Advertisement
                                            </button>
                                        </div>
                                }
                            </Row>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleBusinessSubmit}>
                        Register Business
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default BusinessRegister;